import DescriptionIcon from '@mui/icons-material/Description';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ImageIcon from '@mui/icons-material/Image';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import TableChartIcon from '@mui/icons-material/TableChart';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import { Box } from '@mui/material';

const FILE_ICON_MAP = {
  pdf: PictureAsPdfIcon,

  // images
  jpg: ImageIcon,
  jpeg: ImageIcon,
  png: ImageIcon,
  gif: ImageIcon,
  webp: ImageIcon,
  heic: ImageIcon,

  // documents
  doc: DescriptionIcon,
  docx: DescriptionIcon,
  txt: TextSnippetIcon,

  // spreadsheets
  xls: TableChartIcon,
  xlsx: TableChartIcon,
  csv: TableChartIcon,

  // presentations
  ppt: SlideshowIcon,
  pptx: SlideshowIcon,
};

function FileIcon({ ext, size = 'medium', color = 'primary', ...iconProps }) {
  const IconComponent = (ext && FILE_ICON_MAP[ext]) || InsertDriveFileIcon;

  return (
    <Box
      sx={{
        display: 'flex',
        border: '1px solid #000000',
        borderRadius: '20px',
        width: '40px',
        height: '40px',
        mx: 1,
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <IconComponent size={size} color={color} {...iconProps} />
    </Box>
  );
}

export default FileIcon;
